import { useQuery } from '@tanstack/react-query';
import { type RequestParams } from 'libs/common/services/api/__generated/http-client';

import { fetchUserTransactionHistoryByTransactionId } from '../api';

/**
 * @params fetchUserTransactionHistoryByTransactionId
 * @returns user transaction detail by type transactionId
 */
export const useUserTransactionHistoryByTransactionIdQuery = (transactionId = '', params: RequestParams = {}) =>
	useQuery({
		enabled: !!transactionId,
		queryFn: () => fetchUserTransactionHistoryByTransactionId(transactionId, params),
		queryKey: ['fetchUserTransactionHistoryByTransactionId', transactionId, params],
		staleTime: 1000 * 30 // 30 seconds
	});
